import { useEffect, useState } from "react"
import { IoClose } from "react-icons/io5";

const AddTenderTypeModal = ({ open, onClose, onSave, editData }) => {
    const [form, setForm] = useState({
        tenderTypeName: ""
    });

    useEffect(() => {
        if (open) {
            setForm({
                tenderTypeName: editData?.tenderTypeName || ""
            });
        } else {
            setForm({ tenderTypeName: "" });
        }
    }, [open, editData]);

    if (!open) {
        return null;
    }

    return (
        <div className="admin-modal-overlay">
            <div className="admin-modal">
                <div className="admin-modal-header">
                    <div className="admin-modal-title">
                        {editData ? "Edit Ward" : "Add Ward"}
                    </div>
                    <button className="admin-modal-close" onClick={onClose}>
                        <IoClose />
                    </button>
                </div>



                <div className="admin-form-body">
                    <label className="admin-label">Tender Type Name <span>*</span></label>
                    <input
                        className="admin-input"
                        value={form.tenderTypeName}
                        onChange={(e) => setForm({ ...form, tenderTypeName: e.target.value })}
                        name="tenderTypeName"
                        placeholder="Enter Tender Type Name"
                        required
                    />
                </div>


                <div className="admin-form-footer">
                    <button className="admin-btn-cancel" onClick={onClose}>
                        CANCEL
                    </button>
                    <button className="admin-btn-save" disabled={!form.tenderTypeName.trim() || !form.tenderTypeName.trim()}
                        onClick={() => onSave(form)}>
                        SAVE
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AddTenderTypeModal;